import { Title } from '@angular/platform-browser';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { WithDestroy } from '@lib/shared';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from '../../../user';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent extends WithDestroy() implements OnInit, OnDestroy {
  public form: FormGroup;
  public user: any;
  public passwordRegex = [
    {
      label: '1 lowercase',
      regex: new RegExp('^(?=.*[a-z])')
    },
    {
      label: '1 special character',
      regex: new RegExp('^(?=.*[!@#$%^&*])')
    },
    {
      label: '1 uppercase',
      regex: new RegExp('^(?=.*[A-Z])')
    },
    {
      label: '8 characters',
      regex: new RegExp('^(?=.{8,})')
    },
    {
      label: '1 digit',
      regex: new RegExp('^(?=.*[0-9])')
    }
  ];

  constructor(private fb: FormBuilder, private userService: UserService, private titleService: Title, private toastr: ToastrService) {
    super();
    userService.getActiveUser().subscribe((val) => {
      this.user = val;
    });
  }

  ngOnInit() {
    this.titleService.setTitle('My Profile');
    this.buildForm();
  }

  private buildForm() {
    this.form = this.fb.group({
      currentPassword: [
        null,
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'))
        ]
      ],
      newPassword: [
        null,
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'))
        ]
      ],
      confirmPassword: [
        null,
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'))
        ]
      ]
    });
  }

  public update() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    // New pwd cannot be same as old, new and confirm should match
    if (
      this.newPassword.value.toString() !== this.confirmPassword.value.toString() ||
      this.newPassword.value.toString() === this.currentPassword.value.toString()
    ) {
      return;
    }
    const payload = { currentPassword: this.currentPassword.value, newPassword: this.newPassword.value };
    this.userService
      .updatePassword(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.toastr.success('User password updated successfully!');
      });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  get currentPassword() {
    return this.form.get('currentPassword');
  }

  get newPassword() {
    return this.form.get('newPassword');
  }

  get confirmPassword() {
    return this.form.get('confirmPassword');
  }
}
